import React, { Fragment, useEffect, useState } from "react";
import { Route, Router, Routes, useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import Dashboard from "../../Components/Dashboard/Dashboard";
import LogList from "../../Components/LogList/LogList";
import JobList from "../../Components/JobList/JobList";
import { ProgressBar } from "react-bootstrap";
import ServerInfo from "../../Components/ServerInfo/ServerInfo";
import VUser from "../../Components/User/VUser";
import { getApiUserRoles, getConfigFile, getUserValid, getValid, getValidateKey } from "../../Utils/actions";
import ValidationForm from "../../Components/ValidationForm/ValidationForm";
import { uiLogout } from "../../Utils/actions/auth";
import AppConfig from "../../Components/License/AppConfig";
import MngAcc from "../../Components/User/MngAcc";
import { loadingOn } from "../../Utils/utils";
import Home from "../../Pages/YH/Home";
import Configuration from "../../Pages/YH/Configuraion";

export const OverlayLoader = () => {
    return (
    //     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"> 
    //     <radialGradient id="a9" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
    //         <stop offset="0" stop-color="#49788f"></stop>
    //         <stop offset=".3" stop-color="#49788f" stop-opacity=".9"></stop>
    //         <stop offset=".6" stop-color="#49788f" stop-opacity=".6"></stop>
    //         <stop offset=".8" stop-color="#49788f" stop-opacity=".3"></stop>
    //         <stop offset="1" stop-color="#49788f" stop-opacity="0"></stop>
    //     </radialGradient>
    //     <circle transform-origin="center" fill="none" stroke="url(#a9)" stroke-width="0.5" stroke-linecap="round" stroke-dasharray="100 400" stroke-dashoffset="0" cx="50" cy="50" r="2"> 
    //         <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="1.9" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
    //     </circle>
    //     <circle transform-origin="center" fill="none" opacity=".2" stroke="#49788f" stroke-width="0.5" stroke-linecap="round" cx="50" cy="50" r="2">
    //     </circle>
    // </svg>
    
        <svg version='1.1' width='100' height='100' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' aria-label={"audio-loading"}>
            <circle fill='none' stroke='#286685' strokeWidth='5' cx='50' cy='50' r='25' transform-origin="center" />
            <circle fill='#286685' stroke='#286685' strokeWidth='3' cx='50' cy='75' r='6'>
                <animateTransform attributeName='transform' dur='2s' type='rotate' from='0 50 50' to='360 50 50' repeatCount='indefinite' />
            </circle>
        </svg>
    );
};



const DefaultLayout = (props) => {
    const location = useLocation();
    const { isAuthenticated, isUserValid } = useSelector((state) => state.auth);
    const { isValidKey, isConfigUser } = useSelector((state) => state.data);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [userIsActive, setUserIsActive] = useState(true);

    useEffect(() => {
        if(isValidKey) {
            if (isValidKey && !isConfigUser) {
                dispatch(getConfigFile()); return;
            }
            if (isValidKey && isConfigUser && !isAuthenticated) {
                navigate("/login"); return;
            }
            if(isValidKey && isConfigUser && isAuthenticated) {
                dispatch(getApiUserRoles(sessionStorage.getItem("username")))
                if(location.pathname === '/') {
                    navigate("/dashboard"); return;
                }
            }
        }
        // eslint-disable-next-line
    }, [isAuthenticated, location.pathname, isUserValid, isConfigUser]);

    useEffect(() => {
        let activityTimer;

        const handleUserActivity = () => {
            setUserIsActive(true);

            // Reset the timer when user activity occurs
            clearTimeout(activityTimer);

            // Set a new timer for inactivity
            activityTimer = setTimeout(() => {
                setUserIsActive(false);
            }, 600000); // Adjust the time threshold as needed (e.g., 600000 milliseconds = 10 minutes)
        };

        // Add event listeners for user activity
        window.addEventListener('mousemove', handleUserActivity);
        window.addEventListener('keydown', handleUserActivity);

        // Cleanup: remove event listeners on component unmount
        return () => {
            window.removeEventListener('mousemove', handleUserActivity);
            window.removeEventListener('keydown', handleUserActivity);

            // Clear the timer on unmount
            clearTimeout(activityTimer);
        };
    }, [])

    useEffect(() => {
        if(!isValidKey) {
            dispatch(getValidateKey());
        } else if(isAuthenticated && isValidKey) {
            setTimeout(() => {
                dispatch(getValidateKey());
            }, 300000)
        }
    }, [isValidKey])

    useEffect(() => {
        if (!userIsActive) {
            dispatch(uiLogout());
        }
    }, [userIsActive])


    useEffect(() => {
        dispatch(loadingOn())
    }, [dispatch])

    const { loading, progressLoading, uploadProgress } = useSelector((state) => state.data);

    const cmpntGroup = sessionStorage.getItem("cmpntGroup") !== null ? JSON.parse(sessionStorage.getItem("cmpntGroup")) : '{}';

    const NotFound = () => (
        <>
            <div>
                <h3>You have don't access this page</h3>
                <p>Returning to home...</p>
                <button onClick={() => dispatch(getValidateKey())}>Go to valid form</button>
            </div>
        </>
    )

    return (
        <Fragment>
            <LoadingOverlay active={loading} spinner={<OverlayLoader />} styles={{ content: { display: "flex", height: "100vh", width: "100vw", justifyContent: 'center', alignItems: 'center' } }}>
                <LoadingOverlay
                    active={progressLoading}
                    spinner={<ProgressBar striped animated variant='primary' now={uploadProgress} label={`${uploadProgress} %`} styles={{ content: { width: "50vw" } }} />}
                >
                    {/* <div className="col-md-12 d-flex w-100 overflow-auto"> */}
                    {/* <Container className={"col-md-2"}>
                            <SideBarLink componentName={(cmpnt) => navigate(cmpnt) }/>
                        </Container> */}
                    <Container fluid className={"my-3"}>
                            <Routes>
                               
                            </Routes>
                    </Container>
                    {/* </div> */}
                </LoadingOverlay>
            </LoadingOverlay>
        </Fragment>
    );
};

export default DefaultLayout;
